import { FrameName } from "../config";
import TileEntity from "../TileEntity";

class GravelRoadTileEntity2 extends TileEntity {
	public static readonly frameName = FrameName.GRAVEL_ROAD_2;
}

export default GravelRoadTileEntity2;
